import type { ConfigurationContextValue } from "./ConfigurationContext";

export const defaultDarkModeLogo = "./logos/mentorax-logo-dark.svg";
export const defaultLightModeLogo = "./logos/mentorax-logo-light.svg";

export const defaultCurrency = "USD";

export const defaultTitle = "MentoraX CRM";

export const defaultCompanySectors = [
  { value: "family-law", label: "Family Law" },
  { value: "immigration", label: "Immigration" },
  { value: "criminal-defense", label: "Criminal Defense" },
  { value: "personal-injury", label: "Personal Injury" },
  { value: "estate-planning", label: "Estate Planning" },
  { value: "probate", label: "Probate" },
  { value: "bankruptcy", label: "Bankruptcy" },
  { value: "business-law", label: "Business Law" },
  { value: "employment-law", label: "Employment Law" },
  { value: "real-estate-law", label: "Real Estate Law" },
  { value: "tax-law", label: "Tax Law" },
  { value: "ip-trademark", label: "IP / Trademark" },
  { value: "civil-litigation", label: "Civil Litigation" },
  { value: "elder-law", label: "Elder Law" },
  { value: "healthcare-law", label: "Healthcare Law" },
  { value: "multi-practice", label: "Multi-Practice" },
  { value: "other", label: "Other" },
];

export const defaultDealStages = [
  { value: "lead-qualified", label: "Lead Qualified" },
  { value: "discovery", label: "Discovery" },
  { value: "proposal-sent", label: "Proposal Sent" },
  { value: "verbal-yes", label: "Verbal Yes" },
  { value: "paid-onboarding", label: "Paid / Onboarding" },
  { value: "live-client", label: "Live Client" },
  { value: "completed", label: "Completed" },
  { value: "lost", label: "Lost" },
];

// Stages excluded from the dashboard pipeline widget (closed/won stages)
export const defaultDealPipelineStatuses = ["live-client", "completed", "lost"];

export const defaultDealCategories = [
  { value: "practice-os", label: "Practice OS" },
  { value: "50k-recovery", label: "$50K Recovery" },
  { value: "starflow", label: "StarFlow" },
  { value: "omnicast", label: "OmniCast" },
  { value: "practice-os-infrastructure", label: "Practice OS Infrastructure" },
  { value: "website-development", label: "Website Development" },
  { value: "crm-build", label: "CRM Build" },
  { value: "retainer", label: "Retainer" },
  { value: "other", label: "Other" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Cold", color: "#7DA9E8" },
  { value: "engaged", label: "Engaged", color: "#C9973A" },
  { value: "decision", label: "Decision", color: "#E88B7D" },
  { value: "client", label: "Client", color: "#7FCB8E" },
];

export const defaultTaskTypes = [
  { value: "outreach", label: "Outreach" },
  { value: "follow-up", label: "Follow-up" },
  { value: "qualification", label: "Qualification" },
  { value: "discovery-call", label: "Discovery Call" },
  { value: "proposal", label: "Proposal" },
  { value: "payment", label: "Payment" },
  { value: "onboarding", label: "Onboarding" },
  { value: "delivery", label: "Delivery" },
  { value: "client-check-in", label: "Client Check-in" },
  { value: "upsell", label: "Upsell" },
  { value: "renewal", label: "Renewal" },
  { value: "admin", label: "Admin" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  configVersion: 2,
  allowInitialSignup: false,
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
